import {Component, ElementRef, Input, OnInit, Renderer2, ChangeDetectionStrategy} from '@angular/core';
import {ModalService} from '../../../../components/modal';
import {OverlayService} from '../../../../components/overlay';
import {DisplayDecimal, formatPrice, SymbolDecimalsService} from '../../../../components/symbol-decimals';
import {Security} from '../../../../models/security';
import {CellSizeObserverService} from '../../../../pages/dashboard/layout/cell/cell-size-observer.service';
import {WidgetInnerAlertComponent} from '../../widget-inner-alert';

@Component({
    selector: 'widget-order-min-price-alert',
    templateUrl: 'widget-order-min-price-alert.component.html',
    styleUrls: ['./widget-order-min-price-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetOrderMinPriceAlertComponent extends WidgetInnerAlertComponent implements OnInit {

    @Input()
    public security: Security;

    public minPriceDisplayDecimal: DisplayDecimal<string>;

    constructor(
        elementRef: ElementRef,
        modalService: ModalService,
        overlayService: OverlayService,
        cellSizeObserverService: CellSizeObserverService,
        renderer: Renderer2,
        private symbolDecimalsService: SymbolDecimalsService
    ) {
        super(
            elementRef,
            modalService,
            overlayService,
            cellSizeObserverService,
            renderer
        );
    }

    public override ngOnInit(): void {
        const symbolDecimalsInputParams = this.symbolDecimalsService.getSecurityInputParams(this.security);
        const symbolFormats = this.symbolDecimalsService.getSecurityFormats(this.security);

        this.minPriceDisplayDecimal = formatPrice(
            symbolDecimalsInputParams.min.price,
            symbolFormats
        );

        super.ngOnInit();
    }

}
